/**
 * Parcels Receipt
 */

// React
import React, { useContext, useEffect, useState } from 'react';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import { WrapperReceipt } from './style';
import jMoment from 'moment-jalaali';

// Helper
import { formaterPhoneNumber } from '../../utils/helpers';

// Type
import { Props } from './interfaces';
import AuthContext from '../../authContext';
import Barcode from "react-barcode";
import parcelsRepository from "client-sdk/src/Repository/parcels-repository";
import inventoryItemsRepository from "client-sdk/src/Repository/inventory-items-repository";
import handleError from "../../utils/handleError";
// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(-8),
        },
      },
    },
  })
);

export function Details(props: Props) {
  const classes = useStyles();
  const authContext = useContext(AuthContext);
  const [parcelItemsPage, setParcelItemsPage] = useState([]);
  const [filtersValues, setFiltersValues] = useState({
    outgoingParcelId: { equals: props.match.params.id },
    page: 0,
    size: 10000
  } as any);
  const [parcel, setParcel] = useState({})
  const [inventoryItemsCount, setInventoryItemsCount] = useState<string>("");

  const setLoopPage = (items: any) => {
    const loopItems = [];
    for (let i = 0; i < Math.ceil(items.length / 13); i++) {
      loopItems.push(i + 1);
    }
    setParcelItemsPage(loopItems);
  }
  const getParcelWithId = async (id: any) => {
    const payload = { id };
    try {
      const response = await parcelsRepository.getParcelsWithId({ payload });
      setParcel(response.data);
    } catch (error) {
      handleError(error.response);
    }
  }
  const getParcelInventoryItem = async (actions: any) => {
    const payload = { ...actions };
    try {
      const { response, callback } = await inventoryItemsRepository.getParcelInventoryItems({ payload });
      if (callback) {
        callback();
      }
      setInventoryItemsCount(response.data.totalElements);
    } catch (error) {
      handleError(error.response);
    }
  }
  useEffect(() => {
    const { id } = props.match.params;
    getParcelWithId(id);
    getParcelInventoryItem({
      ...filtersValues
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (parcel.id && inventoryItemsCount) {
      setLoopPage(parcel.items);
    }
  }, [parcel, inventoryItemsCount]);

  useEffect(() => {
    if (parcelItemsPage.length) {
      window.print();
    }
  }, [parcelItemsPage])

  return (
    <WrapperReceipt className={classes.root}>
      {
        parcelItemsPage.map((parcelItem: any, itemIndex: number) => {
          return (
            <div className="page">
              <div className=" wrapper ">
                {/*Section 1 */}
                <div
                  className="flex"
                  style={{
                    marginBottom: '15px',
                  }}
                >
                  <div className="flex flex-column w-100">
                    <div className="flex justify-content-between align-items-center w-100">
                      <div className="logo-box">
                        <div>
                          <img src="/logo-dark.svg" alt="logo" />
                        </div>
                      </div>
                      <div className="title">
                        {(authContext.user.role === 'WAREHOUSE_OPERATOR' ||
                          authContext.user.role === 'WAREHOUSE_ADMIN'
                          ? 'رسید محموله - '
                          : 'حواله محموله - ') + parcel?.id}
                      </div>
                      <div>
                        <Barcode height={'30px'} fontSize={9} value={parcel?.id} />
                      </div>
                    </div>
                    <div className="flex justify-content-between">
                      <div className="flex">
                        <span className="label"> تاریخ ارسال:</span>
                        <span className="bold">
                          {' '}
                          {parcel?.shippingDate &&
                            `${jMoment(parcel?.shippingDate, 'YYYY/MM/DD')
                              .locale('fa')
                              .format('jYYYY/jMM/jDD')}`}
                        </span>
                      </div>
                      <div className="flex">
                        <span className="label"> تاریخ تحویل:</span>
                        <span className="bold">
                          {' '}
                          {parcel?.deliveryDate &&
                            `${jMoment(parcel?.deliveryDate, 'YYYY/MM/DD')
                              .locale('fa')
                              .format('jYYYY/jMM/jDD')}`}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex-1" />
                </div>

                {/* Section 2 */}
                <div className="card-a">
                  <div className="card-a_box">
                    <div className="card-a_item">
                      <span className="card-a_label">{'نام مبدا: '}</span>
                      <span className="card-a_text"> {parcel?.partnerName}</span>
                    </div>
                    <div className="card-a_item">
                      <span className="card-a_label">{'تلفن مبدا: '}</span>
                      <span className="card-a_text">
                        {formaterPhoneNumber(parcel?.sourcePhoneNumber)}
                      </span>
                    </div>
                    <div className="card-a_item">
                      <span className="card-a_label">{'صادر کننده: '}</span>
                      <span className="card-a_text">
                        {' '}
                        {parcel?.sourceAdminName}{' '}
                      </span>
                    </div>
                    <div className="card-a_item">
                      <span className="card-a_label">{'تعداد کل آیتم ها: '}</span>
                      <span className="card-a_text">
                        {' '}
                        {inventoryItemsCount}{' '}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Section 3 */}
                <div className="title" style={{ marginTop: '15px' }}>
                  محتویات محموله
                </div>

                <div className="card-b">
                  <div className="card-b_box">
                    <div className="card-b_header-box">
                      <div className="card-b_header">
                        <div className="card-b_header-item">ردیف</div>
                        <div className="card-b_header-item">نام کالا</div>
                        <div className="card-b_header-item">شناسه تنوع کالا</div>
                        <div className="card-b_header-item">تعداد</div>
                        {/* <div className="card-b_header-item">تعدادکارتن</div> */}
                        {/* <div className="card-b_header-item">نوع کارتن</div> */}
                        <div className="card-b_header-item">توضیحات</div>
                      </div>
                    </div>
                    <div className="card-b_content">
                      {parcel?.items?.map((item: any, index: number) => {
                        if (((parcelItem - 1) * 13) <= index && index < parcelItem * 13) {
                          let variantName = item.productName;
                          for (let i = 0; i <= 2 && item.featureAndValues[i]; i++) {
                            variantName = variantName.concat(
                              ' - ',
                              item.featureAndValues[i].key,
                              ' : ',
                              item.featureAndValues[i].value
                            );
                          }
                          return (
                            <div className="card-b_content-row">
                              <div className="card-b_content-item">{index + 1}</div>
                              <div className="card-b_content-item">{variantName}</div>
                              <div className="card-b_content-item">{item.skuId}</div>
                              <div className="card-b_content-item">{item.inventoryItems.length}</div>
                              <div className="card-b_content-item">{ }</div>
                            </div>
                          );
                        }
                      })}
                    </div>
                  </div>
                </div>

                {/* Section 4 */}
                <div className="title" style={{ marginTop: '15px' }}>
                  توضیحات
                </div>

                <div className="description" />

                {/* Section Last */}
                <div className="sing-box">
                  <div className="item">
                    <span>امضا تحویل دهنده</span>
                    <span>:تاریخ</span>
                  </div>
                  <div className="item">
                    <span>امضا راننده</span>
                    <span>:تاریخ</span>
                  </div>
                  <div className="item">
                    <span>امضا تحویل گیرنده</span>
                    <span>:تاریخ</span>
                  </div>
                </div>
              </div>
            </div>
          )
        }
        )
      }

    </WrapperReceipt>
  );
}


export default Details;
